const FEATURE_FLAG_KEYS = Object.freeze({
   showAltFeaturedImage: `plp-category-featured-image`
});

const FEATURE_FLAG_DEFAULTS = Object.freeze({
   [FEATURE_FLAG_KEYS.showAltFeaturedImage]: false
});

export { FEATURE_FLAG_DEFAULTS, FEATURE_FLAG_KEYS };
